import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { useWorkflowForm } from '../../../../contexts/CampaignWorkflowFormContext';
import { useCallback } from 'react';
import { useSchedulingSelector } from '../../../../state/SplitTests/selectors/useSchedulingSelector';
import moment, { Moment } from 'moment';
import { DateCantBeInThePastRule } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Workflow/Rules/SplitTest/DateCantBeInThePastRule';
import { useTranslation } from 'react-i18next';

export const endDateFormKey = 'end-date';

const validate = (t, endDate: Date) => {
  if (DateCantBeInThePastRule({ date: endDate }).result === 'fail') {
    return {
      passed: false,
      validationMessage: t(
        'onsite.editor.workflow.displayWebContentMessage.scheduling.inlineValidationMessages.endDateInThePast',
      ),
    };
  }

  return {
    passed: true,
    validationMessage: undefined,
  };
};

export const useEndDate = ({ splitTestId }: { splitTestId: string }) => {
  const { t } = useTranslation('campaigns');
  const { actions, state } = useWorkflowForm();
  const { dispatch } = useCampaignEditorContext();

  const onFocusChange = useCallback(
    ({ focused }) => {
      actions.setTouched(endDateFormKey, true);
      actions.setFocused(endDateFormKey, focused);
    },
    [actions],
  );

  const { startDate, endDate } = useSchedulingSelector({ splitTestId }) ?? {};
  const onDateChange = useCallback(
    (endDate: Moment) => dispatch({ type: 'SET_END_DATE', payload: { id: splitTestId, endDate: endDate?.toDate() } }),
    [dispatch, splitTestId],
  );

  const validation = validate(t, endDate);
  const minDate = moment(startDate ?? new Date()).add(1, 'days');

  return {
    endDate: endDate ? moment(endDate) : undefined,
    onDateChange,
    onFocusChange,
    focused: state.focused[endDateFormKey],
    minDate,
    validation,
  };
};
